import { ChangeEvent, memo, useMemo, useRef } from "react";
import classNames from "classnames";
import { v1 } from "uuid";

import styles from "./style.module.scss";

export type SwitcherProps = {
  id?: string,
  value?: boolean,
  checked?: boolean,
  disabled?: boolean,
  onChange?: (e: ChangeEvent<HTMLInputElement>, value: boolean) => void,
  label?: string,
  className?: string,
  style?: object,
  onLabel?: string,
  offLabel?: string,
  hasError?: boolean;
  errorText?: string;
}

const Switcher = memo<SwitcherProps>((
  {
    id,
    value,
    checked,
    disabled,
    onChange,
    label,
    onLabel = "ON",
    offLabel = "OFF",
    className,
    style,
    hasError,
    errorText,
    ...restProps
  }) => {
  const resolvedRef = useRef<any>(null);
  const realId = useMemo(() => id || v1(), [ id ]);
  const onValueChanged = useMemo(() => (e: ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      return onChange?.(e, e.target.checked);
    }
  }, [ disabled, onChange ]);

  return (
    <label
      htmlFor={realId}
      className={classNames(styles.root, className, { [styles.disabled]: disabled })}
      style={style}
    >
      <input
        {...restProps}
        id={realId}
        ref={resolvedRef}
        value={label}
        checked={(value === undefined ? (checked) : value) || false}
        disabled={disabled}
        onChange={onValueChanged}
        type="checkbox"
      />
      <div className={styles.container}>
        {value ? onLabel : offLabel}
        <div role="button" className={styles.swipeCycle} />
      </div>
      <span className={styles.label}>
        {label}
      </span>
    </label>
  );
});

export default Switcher;
